import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import User from "../../APIController/User";
import Form from "../../Components/Form";
import Text from "../../Components/Text";
import TextInput from "../../Components/Form/TextInput";
import Button from "../../Components/Buttons/Button";
import Snackbar from "../../Components/Elements/Snackbar";

const SignUpPage = () => {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFristName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const navigate = useNavigate();
  const { register } = User();

  const handleLogin = () => {
    navigate("/login");
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (password !== passwordConfirm) {
      setSnackbarMessage("Passwörter stimmen nicht überein")
      return
    }

    const body = {
      email: email,
      firstName: firstName,
      lastName: lastName,
      password: password
    }

    const registerResponce = await register(body)
    if (registerResponce.ok) {
      setSnackbarMessage("Registrierung erfolgreich! Bitte logge dich ein.")
      navigate("/login");
    } else {
      const errorText = await registerResponce.text();
      setSnackbarMessage(`Registrierung fehlgeschlagen: ${errorText}`)
    }
  };

  return (
    <>
      <Form onSubmitAction={handleSignUp} submitButtonText={"Account erstellen"} size="w-full" background="bg-white" border="">
        <Text type="maintitle" classNames={"flex text-center justify-center"}>{"Registrierung"}</Text>
        <TextInput placeholder={"E-Mail"} value={email} action={(e) => setEmail(e.target.value)} type={"email"} />
        <TextInput placeholder={"Vorname"} value={firstName} action={(e) => setFristName(e.target.value)} />
        <TextInput placeholder={"Nachname"} value={lastName} action={(e) => setLastName(e.target.value)} />
        <TextInput placeholder={"Password"} value={password} action={(e) => setPassword(e.target.value)} type="password" />
        <TextInput placeholder={"Password bestätigen"} value={passwordConfirm} action={(e) => setPasswordConfirm(e.target.value)} type="password" />
      </Form>
      <div className="flex flex-row items-center p-2">
        <Text type="buttontext">Lieber einloggen?</Text>
        <Button classNames="text-blue-500 hover:underline" buttonColor="transparent" borderStyle="" text={"Zur Anmelde Seite"} onClickAction={() => handleLogin()} />
      </div>
      <Snackbar message={snackbarMessage} onClose={() => setSnackbarMessage("")} />
    </>
  );
};

export default SignUpPage;
